// extracted by mini-css-extract-plugin
module.exports = {"headerImage":"BundleHeaderPageSegment-HeaderImage-module--header-image--1iaoZ"};